import React from "react";
import Navbar from "../../components/Navbar";
import DealSummary from "../../components/Dashboard/DealSummary";
import DoughnutReport from "../../components/Dashboard/DoughnutReport";
import BarChartSummary from "../../components/Dashboard/BarChartSummary";
import RecentDeals from "../../components/Dashboard/RecentDeals";
import PermissionDebug from "../../components/Permissions/PermissionDebug";
import AuthGuardDebug from "../../components/Permissions/AuthGuardDebug";
import LimitedAccessMessage from "../../components/Permissions/LimitedAccessMessage";
import { useState } from "react";
import { useEffect } from "react";
import DashboardRequests from "../../requests/vendor/DashboardRequests";
import {toast} from "react-toastify";
import Loader from "../../components/Loader";

const Dashboard = () => {
  const [recentDeals, setRecentDeals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statsDealsCampaigns, setStatsDealsCampaigns] = useState(null);
  const [isStatsDealsCampaignsLoading, setIsStatsDealsCampaignsLoading] = useState(true);
  const [dealSummaryLoading, setDealSummaryLoading] = useState(true);
  
  useEffect(()=>{
    const fetchStatsDealsCampaigns = async () => {  
      try{
        setIsStatsDealsCampaignsLoading(true);
        const response = await DashboardRequests.getStatsDealsCampaigns();
        if(response.data?.status_code === "000"){
          setStatsDealsCampaigns(response.data?.data);
        }else{
          toast.error(response.data?.reason || 'Error fetching stats deals campaigns');
        }
      }catch(err){
        toast.error('Error fetching stats deals campaigns');
      }finally{
        setIsStatsDealsCampaignsLoading(false);
      }
    };
    fetchStatsDealsCampaigns();
  },[]);

  useEffect(() => {
    let isMounted = true;

    const fetchRecentDeals = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        const recentDealsResponse = await DashboardRequests.getRecentDeals();

        if (!isMounted) return;

        if (recentDealsResponse?.data?.status_code === "000") {
          const lastFiveDeals = recentDealsResponse.data?.data?.slice(-5) || [];
          setRecentDeals(lastFiveDeals);
        } else {
          setError(recentDealsResponse?.data?.reason || 'Failed to fetch recent deals');
          toast.error(recentDealsResponse?.data?.reason || 'Failed to fetch recent deals');
        }
      } catch (err) {
        if (!isMounted) return;
        const errorMessage = 'Error fetching recent deals';
        setError(errorMessage);
        toast.error(errorMessage);
        console.error('Recent deals fetch error:', err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchRecentDeals();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, []);

  if(isStatsDealsCampaignsLoading){
    return <Loader />;
  }
  
  return (
    <div className="bg-[#fcfcfc]">
      <Navbar page="Dashboard" />
      <div className="px-6 py-6">
        {/* Temporary debug components - remove in production */}
        {/* <AuthGuardDebug /> */}
        <PermissionDebug />
        <LimitedAccessMessage />
        
        <DealSummary statsDealsCampaigns={statsDealsCampaigns} />
        <div className="grid grid-cols-1 gap-4 py-6 md:grid-cols-3">
          <div className="col-span-1 bg-white md:col-span-1">
            <DoughnutReport />
          </div>
          <div className="col-span-1 bg-white md:col-span-2">
            <BarChartSummary />
          </div>
        </div>
        <RecentDeals 
          deals={recentDeals}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </div>
  );
};

export default Dashboard;
